export const heroContent = {
  backgroundWord: 'ПРИЧАЛ',
  leftText: '<strong>малоэтажный <br> квартал </strong> на первой<br/> линии Камы',
  rightTitle: 'курортная <br/>жизнь',
  rightText: '<span>в 15 минутах <strong>от центра Перми</strong></span>',
};
